import { NavLink, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { all_routes } from "../../../../router/all_routes";
import TeacherBreadcrumb from "./teacherBreadcrumb";
import useTeacher from "../hooks/useTeacher";
import { useEffect, useMemo } from "react";
import PageHeader from "components/Common/PageHeader";
import CustomButton from "components/Common/ui/CustomButton";
import { useAbility } from "config/abilityContext";

type OutletCtx = {
  teacher: ReturnType<typeof useTeacher>["teacher"];
};
const TeacherDetailsLayout = () => {
  const { t } = useTranslation();
  const routes = all_routes;
  const { id } = useParams<{ id: string }>();
  const { fetchTeacherById, teacher } = useTeacher();
  const ability = useAbility();
  useEffect(() => {
    if (id) {
      fetchTeacherById(id);
    }
  }, []);
  const outletContext = useMemo<any>(() => ({ teacher }), [teacher]);

  if (!teacher) return null

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={
            teacher
              ? `${teacher.user?.firstName || ""} ${teacher.user?.lastName || ""}`.trim() || t("teacher_details")
              : t("teacher_details")
          }
          breadcrumbItems={[
            { label: t("dashboard"), path: all_routes.dashboard },
            { label: t("teachers"), path: all_routes.teacherList },
            { label: t("teacher_details"), active: true },
          ]}
        />

        {
          ability.can("update", "Teacher") && (
            <div className="d-flex justify-content-end">
              <CustomButton asLink to={all_routes.editTeacher.replace(":id", teacher.id)} className="">
                <i className="ti ti-edit-circle me-2" />
                {t("edit_teacher")}
              </CustomButton>
            </div>
          )
        }

        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              {/* Tabs */}
              <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                {ability.can("getAll", "Teacher") && (
                  <li>
                    <NavLink
                      to={id ? `${routes.teacherDetails.replace(':id', id)}${routes.teacherDetailsTabs.details}` : '#'}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      <i className="ti ti-users me-2" /> {t("details")}
                    </NavLink>
                  </li>
                )}
                {ability.can("getAll", "Planner") && (
                  <li>
                    <NavLink
                      to={id ? `${routes.teacherDetails.replace(':id', id)}${routes.teacherDetailsTabs.routine}` : '#'}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      <i className="ti ti-table-options me-2" /> {t("routine")}
                    </NavLink>
                  </li>
                )}
                {ability.can("getAll", "Task") && (
                  <li>
                    <NavLink
                      to={id ? `${routes.teacherDetails.replace(':id', id)}${routes.teacherDetailsTabs.tasks}` : '#'}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      <i className="ti ti-license me-2" /> {t("homework")}
                    </NavLink>
                  </li>
                )}
                {ability.can("getAll", "Leave") && (
                  <li>
                    <NavLink
                      to={id ? `${routes.teacherDetails.replace(':id', id)}${routes.teacherDetailsTabs.leaves}` : '#'}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      <i className="ti ti-confetti me-2" /> {t("leave.title")}
                    </NavLink>
                  </li>
                )}
                {ability.can("update", "Teacher") && (
                  <li>
                    <NavLink
                      to={id ? `${routes.teacherDetails.replace(':id', id)}${routes.teacherDetailsTabs.classes}` : '#'}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                    >
                      <i className="ti ti-school-bell me-2" /> {t("classes")}
                    </NavLink>
                  </li>
                )}
              </ul>
              {/* Tabs */}
            </div>
          </div>
          {/* Render Child Components */}
          <Outlet context={outletContext} />
        </div>
      </div>
    </div>
    // </div>
  );
};

export default TeacherDetailsLayout;
